<template>
  <button
    v-if="downloads.length > 0"
    type="button"
    @click="isOpen = !isOpen"
    class="-m-2.5 p-2.5 relative text-neutral-400 hover:text-neutral-500 dark:hover:text-neutral-300">
    <Transition
      enter-from-class="scale-0"
      leave-to-class="scale-0"
      enter-active-class="transition"
      leave-active-class="transition">
      <span v-if="isGenerating" class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <i
          class="fa-sharp fa-regular fa-spinner-third fa-spin fa-fw text-accent-500 dark:text-accent-600 text-4xl"
          aria-hidden="true"></i>
      </span>
    </Transition>

    <span class="sr-only">View downloads</span>
    <i class="fa-sharp fa-regular fa-download fa-fw" aria-hidden="true"></i>
    <span
      class="absolute min-w-4 -bottom-0.5 -right-0.5 bg-red-600 dark:bg-red-700 px-1 rounded-full text-white text-xs">
      {{ downloads.length }}
    </span>
  </button>

  <Transition
    enter-active-class="transition ease-out duration-100 origin-top"
    enter-from-class="transform opacity-0 scale-95"
    enter-to-class="transform opacity-100 scale-100"
    leave-active-class="transition ease-in duration-75 origin-top"
    leave-from-class="transform opacity-100 scale-100"
    leave-to-class="transform opacity-0 scale-95">
    <div
      v-if="isOpen"
      class="absolute z-10 right-4 top-full max-h-72 overflow-y-auto bg-white dark:bg-neutral-800 rounded-b-md shadow-lg divide-y divide-neutral-200 dark:divide-neutral-700 border border-neutral-300 dark:border-neutral-700">
      <div
        class="w-full flex py-3 px-4 items-center gap-3 leading-tight"
        v-for="download in downloads"
        :key="download.id">
        <div class="w-56">
          <strong class="block text-black dark:text-white font-semibold text-sm">
            {{ download.filename }}
          </strong>
          <small class="text-neutral-500 dark:text-neutral-400">
            <i
              v-if="[0, 1].includes(download.status_id)"
              class="fa-sharp fa-regular fa-spinner-third fa-spin fa-fw text-accent-500 dark:text-accent-600"
              aria-hidden="true"></i>
            <i
              v-if="download.status_id === 3"
              class="fa-sharp fa-exclamation-triangle fa-fw text-red-500 dark:text-red-600"
              aria-hidden="true"></i>
            {{
              download.status_id === 2
                ? `Expires: ${$filters.datetime(download.expires_at)}`
                : $filters.trans('download.status', download.status_id)
            }}
          </small>
        </div>
        <button
          class="w-8 h-8 bg-neutral-100 dark:bg-neutral-700 hover:enabled:bg-neutral-200 dark:hover:enabled:bg-neutral-600 text-neutral-400 disabled:text-neutral-300 dark:disabled:text-neutral-500 hover:enabled:text-neutral-500 dark:hover:enabled:text-neutral-300 rounded-full flex items-center justify-center"
          title="Delete"
          :disabled="[0, 1].includes(download.status_id)"
          @click="deleteDownload(download.id)">
          <i class="fa-sharp fa-regular fa-trash-alt fa-fw" aria-hidden="true"></i>
        </button>
        <component
          :is="download.url ? 'a' : 'span'"
          title="Download"
          :href="download.url"
          :target="download.url ? '_blank' : null"
          class="w-8 h-8 rounded-full flex items-center justify-center"
          :class="
            download.url
              ? 'bg-accent-500 hover:bg-accent-400 dark:bg-accent-600 dark:hover:bg-accent-500 text-white cursor-pointer'
              : 'bg-neutral-100 dark:bg-neutral-700 text-neutral-300 dark:text-neutral-500'
          ">
          <i class="fa-sharp fa-regular fa-download fa-fw" aria-hidden="true"></i>
        </component>
      </div>
    </div>
  </Transition>
</template>

<script>
import { useNotificationStore } from '@/stores/notifications'
import { mapActions, mapState } from 'pinia'

export default {
  computed: {
    ...mapState(useNotificationStore, ['downloads']),
    isGenerating() {
      return this.downloads.filter((d) => [0, 1].includes(d.status_id)).length > 0
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    ...mapActions(useNotificationStore, ['deleteDownload'])
  },
  watch: {
    downloads: {
      handler() {
        setTimeout(() => {
          this.isOpen = true
        }, 33)
      },
      deep: true
    }
  }
}
</script>
